import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
export function IdentificationSection() {
  const painPoints = ['Jugás 2–5 horas por día y no ves mejora real', 'Te enoja perder contra jugadores que “no son mejores”', 'Sentís que sos bueno… pero algo te falta', 'Mirás videos en YouTube y no progresás', 'Te tilteás y empezás a jugar peor', 'Querés subir de nivel pero no sabés qué estás haciendo mal'];
  return <section className="py-20 bg-slate-900 relative overflow-hidden" data-id="element-117">
      {/* Diagonal stripes background */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #000 0, #000 10px, transparent 10px, transparent 20px)'
    }} data-id="element-118" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-119">
        <div className="max-w-4xl mx-auto" data-id="element-120">
          <div className="text-center mb-12" data-id="element-121">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-122">
              Si esto te pasa…{' '}
              <span className="text-red-500" data-id="element-123">esta guía es para vos.</span>
            </h2>
            <div className="h-1 w-24 bg-red-600 mx-auto rounded-full" data-id="element-124" />
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-125">
            {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4 bg-slate-950/50 p-6 rounded-lg border border-slate-800 hover:border-red-500/50 transition-colors duration-300" data-id="element-126">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-127" />
                <p className="text-lg text-slate-300 font-medium" data-id="element-128">{point}</p>
              </div>)}
          </div>

          <div className="mt-16 text-center bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 p-8 rounded-2xl border border-slate-700 shadow-xl" data-id="element-129">
            <div className="flex justify-center mb-4" data-id="element-130">
              <AlertTriangle className="w-12 h-12 text-yellow-500 animate-pulse" data-id="element-131" />
            </div>
            <p className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-132">
              El problema no es que seas malo.
            </p>
            <p className="text-xl md:text-2xl text-blue-400 font-bold uppercase tracking-wider" data-id="element-133">
              El problema es que estás jugando sin sistema.
            </p>
          </div>
        </div>
      </div>
    </section>;
}